// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactIcons_wrapper__xTPzR","icon":"ContactIcons_icon__X+lOT","title":"ContactIcons_title__o0CzT","description":"ContactIcons_description__6VU94"};